import client from '../httpClient';

const simulatorDownLoadSampleApi = (params) => {
  const responseType = 'arraybuffer';
  return client.get('/simulator/csv-download', { params, responseType });
};

export default simulatorDownLoadSampleApi;
